import { IconDefinition, IconName, IconPrefix } from '@fortawesome/fontawesome-common-types';

export const tacs3Absence: IconDefinition = {
  prefix: 'tacs3' as IconPrefix,
  iconName: 'absence' as IconName,
  icon: [
    16,
    16,
    [],
    '&#xe801;',
    'm 1.8 0.1 v 15.9 h 9.3 l 3.1 -3.3 v -12.6 h -12.4 z m 1.2 5.1 h 8.3 c 0.3 0 0.6 -0.3 0.6 -0.6 c 0 -0.3 -0.3 -0.6 -0.6 -0.6 h -8.3 v -2.8 h 10 v 10.6 c -0.7 0 -1.6 0 -2 0 c -0.5 0 -0.7 0.4 -0.7 0.6 c 0 0.2 0 1.4 0 2.3 h -7.3 v -9.5 z m 7.2 5 l -1.3 -1.3 c 0.5 -0.4 1 -0.8 1.6 -1.2 c 0.3 -0.2 0.3 -0.6 0.1 -0.8 c -0.2 -0.3 -0.6 -0.4 -0.8 -0.2 c -0.7 0.5 -1.2 0.9 -1.7 1.4 l -1.5 -1.5 c -0.2 -0.2 -0.6 -0.2 -0.8 0 c -0.2 0.2 -0.2 0.6 0 0.8 l 1.4 1.4 c -1.5 1.5 -2.2 2.6 -2.3 2.7 c -0.2 0.3 -0.1 0.6 0.2 0.8 c 0.1 0.1 0.2 0.1 0.3 0.1 c 0.2 0 0.4 -0.1 0.5 -0.3 c 0 0 0.7 -1.1 2.1 -2.5 l 1.4 1.4 c 0.1 0.1 0.3 0.2 0.4 0.2 s 0.3 -0.1 0.4 -0.2 c 0.3 -0.1 0.3 -0.5 -0 -0.8 z',
  ],
};
